import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TaskExecutor.module.css';

interface TaskExecutorProps {
    name: string;
    avatarSrc: string;
    classes?: string;
}

export const TaskExecutor = memo(({ name, avatarSrc, classes }: TaskExecutorProps) => {
    if (!name || !avatarSrc) return null;

    return (
        <div className={classNames(cls.TaskExecutor, [classes])} title={name}>
            <img src={avatarSrc} alt={name} />
            {/*<span>{name}</span>*/}
        </div>
    );
});
